
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/surveyTaking/[collectKey]",
      function () {
        return require("private-next-pages/r/surveyTaking/[collectKey].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/surveyTaking/[collectKey]"])
      });
    }
  